import { useEffect, useState } from 'react';

import { AuthService } from 'shared/lib/keycloak';
import { useAppSelector } from 'shared/lib/redux';
import { useGetOnboardingUserInfoQuery } from 'shared/api/onboarding';

export const useIsDistrictAdminUserCheck = () => {
  const userBk = AuthService.getUserBk();

  const [isUserDistrictAdmin, setIsUserDistrictAdmin] = useState<
    boolean | null
  >(null);

  const hasError = useAppSelector(
    (state) =>
      state.onboarding.queries[`getOnboardingUserInfo("${userBk}")`]?.status ===
      'rejected',
  );

  const { data: onboardingUserInfo } = useGetOnboardingUserInfoQuery(userBk, {
    skip: !userBk || hasError,
  });

  useEffect(() => {
    if (!onboardingUserInfo) return;

    setIsUserDistrictAdmin(
      onboardingUserInfo.role === 'district administrator',
    );
  }, [onboardingUserInfo]);

  return isUserDistrictAdmin;
};
